// extracted by mini-css-extract-plugin
export default {"text":"Sfourth_text__PfYZ7","title":"Sfourth_title__TafdR","Sfourth_desc":"Sfourth_Sfourth_desc__mPwyZ","Sfourth":"Sfourth_Sfourth__U2hMe","wrap":"Sfourth_wrap__PKInn"};